<template>
    <div>

        <el-form :model="from" :rules="rules" ref="from" style="padding: 0 10%;" label-width="100px">
            <el-form-item label="退住时间" prop="ssmc">
                <el-date-picker v-model="value1" type="date" placeholder="选择日期" style="width: 100%;">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="退住原因" prop="ssdz">
                <el-input v-model="from.ssdz" placeholder="请输入楼层" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;" label-width="0px">
                <el-button type="primary" @click="Add"
                    style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data() {
            return {
                from: {
                    xmid: "",
                    ssmc: "",
                    ssdz: "",
                    fzrid: "",
                    fzrdh: ""
                }
            };
        },
        methods: {
            Return() {
                this.$parent.$parent.Return();
            },
            Add() {
                this.Return();
            }
        },
        created() {

        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// SstzGl_edit.vue?3b6c8a6c